import { Component, Optional } from '@angular/core';
import { DokItemInfo } from '@app/components/dokumentacija/dokumentacija-types';
import {
  ItemProvider,
  NotificationService,
  ViewWindow,
  WindowRegistry
} from '@ntap/core';
import { DokumentacijaOpenItemViewActionComponent } from './openitemview-dokumentacija';

@Component({
  selector: 'app-read-jedgraddok-action',
  templateUrl: './primeng-button-template.html'
})
export class ReadJedinicaGradivaDokComponent extends DokumentacijaOpenItemViewActionComponent {
  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    @Optional() protected override itemProvider: ItemProvider
  ) {
    super(notificationService, windowRegistry, window, itemProvider);
  }

  protected override isDisabled(dokInfo: DokItemInfo): boolean {
    return dokInfo.permission < 1; // WRITE
  }
}
